import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { distances } from '@setvi/shared/styles';

export const Placeholder = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  textAlign: 'center',
  p: 4
});

export const QuestionsContainer = styled(Box)({
  borderRadius: 16,
  padding: distances.px.base,
  border: '1px solid #EEF0F2',
  overflow: 'hidden auto',
  width: '25%',
  minWidth: 250
});

export const QuestionsTitle = styled(Box)({
  padding: '0px 0px 0px 10px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap'
});

export const QuestionsWrapper = styled(Box)({
  marginTop: 12,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  minWidth: 240,
  gridGap: '4px'
});

export const Question = styled(SButton)({
  display: 'flex',
  justifyContent: 'flex-start',
  borderRadius: 99,
  padding: 12,
  minWidth: 'unset',
  textAlign: 'left',
  overflow: 'hidden',
  fontWeight: 'normal'
});

export const ChatContainer = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
});

export const ChatContent = styled(Box)({
  flex: 1,
  margin: 'auto',
  width: '100%',
  height: 'fit-content',
  justifyContent: 'start',
  alignItems: 'flex-start',
  overflow: 'hidden auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: 4,
  marginBottom: 6
});

export const ChatBox = styled(Box)({
  display: 'flex',
  gap: 12,
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '100%',
  height: 'fit-content'
});

export const UserBox = styled(Box)(({ theme }) => ({
  width: '92%',
  display: 'flex',
  margin: 'auto',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 2)
}));

export const AIBox = styled(Box)(({ theme }) => ({
  width: '90%',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'flex-start',
  gap: 8,
  padding: theme.spacing(0, 2)
}));

export const IconBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #d9d9d9',
  borderRadius: '50%',
  width: 35,
  height: 35,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)'
});

export const Message = styled(Box)(({ theme }) => ({
  minHeight: 36,
  background: '#fff',
  borderRadius: 12,
  maxWidth: '60%',
  wordBreak: 'break-word',
  padding: theme.spacing(2),
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.3s ease'
}));

export const TextareaBox = styled(Box)({
  margin: 'auto',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
